import { render, staticRenderFns } from "./KaihatsuTypeSelector.vue?vue&type=template&id=3c39b427&scoped=true&"
import script from "./KaihatsuTypeSelector.vue?vue&type=script&lang=js&"
export * from "./KaihatsuTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./KaihatsuTypeSelector.vue?vue&type=style&index=0&id=3c39b427&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39b427",
  null
  
)

export default component.exports